var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { CountryConfiguration } from "./../models/V1/Cesop/Configuration/CountryConfiguration";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class CountryConfigurations {
  /**
   * Creates an instance of CountryConfigurations.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CountryConfigurations
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetConfigurationRq_ _getConfigurationRq
   * @returns Promise<GetConfigurationRq_>
   * @memberof CountryConfigurations
   */
  getConfiguration(pGetConfigurationRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/cesop/CountryConfigurations/{countryCode}", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "countryCode", value: pGetConfigurationRq.countryCode, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: CountryConfiguration },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
